import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from './FIRST4COM.png';
import './index.css';

const API_URL = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    
    try {
      const response = await fetch(`${API_URL}/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ login: username, password })
      });
      const data = await response.json();
      if (data.success) {
        navigate('/products');
      } else {
        setError('Identifiant ou mot de passe incorrect');
      }
    } catch (err) {
      console.error('Login Error:', err);
      setError('Erreur de connexion au serveur (Vérifiez votre URL API)');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-background">
        <div className="bg-blob blob-1"></div>
        <div className="bg-blob blob-2"></div>
        <div className="bg-blob blob-3"></div>
      </div>
      
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <div className="logo-wrapper">
              <img src={logo} alt="First4Com Logo" className="main-logo" />
            </div>
            <h1>Bienvenue</h1>
            <p className="subtitle">Accédez à votre portail de gestion First4Com</p>
          </div>

          {error && (
            <div className="error-banner">
              <span className="error-icon">⚠️</span>
              {error}
            </div>
          )}

          <form onSubmit={handleLogin} className="login-form">
            <div className="input-group">
              <label htmlFor="username">Identifiant Administrateur</label>
              <div className="input-wrapper">
                <span className="input-icon">👤</span>
                <input 
                  id="username"
                  type="text" 
                  value={username} 
                  onChange={(e) => setUsername(e.target.value)} 
                  placeholder="Nom d'utilisateur"
                  required 
                  disabled={isLoading}
                />
              </div>
            </div>

            <div className="input-group">
              <label htmlFor="password">Mot de passe</label>
              <div className="input-wrapper">
                <span className="input-icon">🔒</span>
                <input 
                  id="password"
                  type={showPassword ? "text" : "password"} 
                  value={password} 
                  onChange={(e) => setPassword(e.target.value)} 
                  placeholder="••••••••"
                  required 
                  disabled={isLoading}
                />
                <button 
                  type="button" 
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex="-1"
                >
                  {showPassword ? "👁️" : "🙈"}
                </button>
              </div>
            </div>

            <button type="submit" className="login-submit-btn" disabled={isLoading}>
              {isLoading ? (
                <span className="loader"></span>
              ) : (
                <>
                  Se connecter
                  <span className="btn-arrow">→</span>
                </>
              )}
            </button>
          </form>
          
          <div className="login-footer">
            <p>&copy; 2026 First4Com. Tous droits réservés.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
